import React, { useRef } from 'react'
import { Grid, useMediaQuery } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { PanelBarGLPure, GridSelectionHLPure, ButtonAddHLPure, ButtonTrashHLPure } from '../../pures'
import { ArrowBtnMobile } from '../../../assets/logos/icons'

const DocumentPanelBarExpediente = (props) => {

    let {
        filesExpediente,
        handleWatchExp,
        handleSelectFileExp,
        showBtnAddDocumentToExp,
        addNewFileToExp,
        handleDeleteDoc,
        isInDeleteFlow
    } = props

    const { t } = useTranslation()
    const fileRef = useRef(null)
    const is1260 = useMediaQuery('(max-width:1260px)');
    const is960 = useMediaQuery('(max-width:960px)');
    const is610 = useMediaQuery('(max-width:610px)');

    const headerColumnOne = (props) => {
        return <span className='documentPanelBarExpediente-header-cell-one'>{props.title}</span>
    }

    const headerColumnTwo = (props) => {
        return <span className='documentPanelBarExpediente-header-cell-two'>{props.title}</span>
    }

    const cellColumnOne = (props) => {
        const documentName = (props.dataItem && props.dataItem.document && props.dataItem.document.name) ? props.dataItem.document.name : `${props.dataItem.name}.${props.dataItem.extension}`
        return (
            <td className={`documentPanelBarExpediente-cell-one ${props.dataItem.selected ? 'documentPanelBarVersions-cell-selected' : ''}`} onClick={() => handleSelectFileExp(props.dataItem)}>
                <span className='gridHLPure-userName'>
                    {documentName}
                </span>
            </td>
        )
    }

    const cellColumnTwo = (props) => {
        const { dataItem } = props
        const documentSelected = (dataItem && dataItem.document && dataItem.document.id) ? dataItem.document : null

        return (
            <td className={`documentPanelBarExpediente-cell-two ${dataItem.selected ? 'documentPanelBarVersions-cell-selected' : ''}`} onClick={() => handleSelectFileExp(dataItem)}>

                {
                    !isInDeleteFlow && (
                        <div className='documentPanelBarExpediente-general-grid-col-2'>
                            <div
                                className='cellActions-mobileExpanded'
                                onClick={() => handleWatchExp(dataItem)}
                            >
                                <img
                                    className='cellActions-icon-arrow'
                                    alt={'cellActions-arrow'}
                                    src={ArrowBtnMobile}
                                />
                            </div>
                            <button className='grid-btn-action' onClick={() => handleWatchExp(dataItem)}>
                                <p>{t('documentPanelBarExpediente-watch-doc')}</p>
                            </button>
                            <ButtonTrashHLPure openDelay={600} onClickBtn={() => handleDeleteDoc(documentSelected)} />
                        </div>
                    )
                }
            </td >
        )
    }

    const heightGrid = 'var(--panelHeight)'

    const addFile = (ref) => {
        ref.current.click()
    }

    return (
        <div className='documentPanelBarExpediente-container'>
            <PanelBarGLPure
                expandedPanel={true}
                titlePanel={t('documentPanelBarExpediente-docs-exp')}
                className='documentPanelBarExpediente-panel'
                id='documentPanelBarExpediente'
                actionComponent={showBtnAddDocumentToExp && (
                    <ButtonAddHLPure
                        nameBtn={is1260
                            ? is960
                                ? is610
                                    ? ''
                                    : t('documentPanelBarExpediente.btn.new.doc')
                                : ''
                            : t('documentPanelBarExpediente.btn.new.doc')
                        }
                        onClickBtn={() => addFile(fileRef)}
                        iconAdd
                        disabled={isInDeleteFlow}
                    />
                )}
            >
                <Grid item className='documentPanelBarExpediente-grid-documents'>
                    <GridSelectionHLPure
                        styleGeneral={true}
                        styleGeneralClass={'documentPanelBarExpediente-general-grid'}
                        pageable={false}
                        skip={0}
                        take={filesExpediente.length}
                        dataGrid={filesExpediente}
                        filter={false}
                        columnTwo={true}
                        titleRow1={t('documentPanelBarExpediente-file')}
                        titleRow2={t('documentPanelBarExpediente-action')}
                        headerColumnOne={headerColumnOne}
                        headerColumnTwo={headerColumnTwo}
                        cellColumnOne={cellColumnOne}
                        cellColumnTwo={cellColumnTwo}
                        styleGrid={{ height: heightGrid }}
                    />
                </Grid>
            </PanelBarGLPure>
            <input
                ref={fileRef}
                onChange={(e) => addNewFileToExp(e)}
                type='file'
                id='fileExp'
                accept='application/pdf'
                style={{ display: 'none' }}
            />
        </div>
    )
}

export { DocumentPanelBarExpediente as default }